import { Tooltip as C } from "./index.es5524.js";
const H = (u, r, f) => ({
  tooltipValueGetter: (c) => {
    var b;
    const j = {
      data: c.value,
      rowData: c.data
    }, w = (b = r == null ? void 0 : r.validator) == null ? void 0 : b.call(r, j), s = r == null ? void 0 : r.getTooltipText;
    return w ? s == null ? void 0 : s(c) : u == null ? void 0 : u(c);
  },
  tooltipComponent: f || C
});
export {
  H as getTooltipHandling
};
//# sourceMappingURL=index.es2346.js.map
